import React from 'react';
import styled from 'styled-components/macro';
import { InputNumber, InputGroup, Icon, IconButton } from 'rsuite';
import CloseIcon from '@rsuite/icons/Close';

const Title = styled.div`
  height: 18px;
  margin-bottom: 18px;
  font-family: Lato;
  font-size: 15px;
  font-weight: bold;
  color: #000;
`;

// const Year = styled.div`
//     font-size: 15px;
//     font-weight: bold;
//     font-stretch: normal;
//     font-style: normal;
//     line-height: normal;
//     letter-spacing: normal;
//     color: #000000;
//     margin-top: 40px;
// `;

const Title2Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 5px;
  padding-right: 1px;
  width: max-content;
`;

const Title2 = styled.div`
  margin-right: 5px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #7f8fa4;
`;

const InputGrid = styled.div`
  display: grid;
  grid-template-columns: 230px 230px auto;
  margin-bottom: 40px;
  grid-gap: 80px;
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 13px;
`;

function InputItem({ setPeriodInputValue, valuePath, value, title, tooltipInfo, error }) {
  return (
    <div>
      <Title2Wrapper>
        <Title2>{title}</Title2>
        <span aria-label={tooltipInfo} data-balloon-pos="up">
          <Icon icon="info" />
        </span>
      </Title2Wrapper>

      <InputGroup>
        <InputGroup.Addon>$</InputGroup.Addon>

        <InputNumber
          min={0}
          max={999999}
          value={value}
          onChange={(newValue) => setPeriodInputValue(valuePath, newValue)}
        />
      </InputGroup>

      {Boolean(error?.length) && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
}

function PeriodInputs({ year, periods, setPeriodInputValue }) {
  return (
    <div>
      {periods.slice().reverse().map((item, i) => { // slice bc array in strict mode, can't reverse
        if (!item.checked) return null;

        const index = periods.length - 1 - i; // calculate index from last to first bc reversed

        const grossRevenuePath = `${year}[${index}].grossRevenue`;
        const grossExemptRevenuePath =  `${year}[${index}].grossExemptRevenue`;
        const checkedPath = `${year}[${index}].checked`;

        return (
          <div key={`${year}-${item.label}`}>
            <Title>{item.longLabel(year)}</Title>
            <InputGrid>
              <InputItem
                title="Total Gross Revenues Charged"
                value={item.grossRevenue}
                valuePath={grossRevenuePath}
                error={item.grossRevenueError}
                setPeriodInputValue={setPeriodInputValue}
                tooltipInfo="Gross Revenue shall not include Federal, State or Local Taxes collected"
              />
              <InputItem
                title="Total Exempt Gross Revenues"
                value={item.grossExemptRevenue}
                valuePath={grossExemptRevenuePath}
                error={item.grossExemptRevenueError}
                setPeriodInputValue={setPeriodInputValue}
                tooltipInfo="Gas, propane, fishing licenses, service charges, non-taxable food items"
              />
              {!item.fixed &&
                <div css="display: flex; align-items: flex-end; padding-bottom: 7px">
                  <IconButton
                    appearance="subtle"
                    icon={<CloseIcon />}
                    circle
                    size="xs"
                    onClick={() => setPeriodInputValue(checkedPath, false)}
                  />
                </div>
              }
            </InputGrid>
          </div>
        );
      })}
    </div>
  );
}

export function RevenueInput({ year, periods, setPeriodInputValue }) {
  return (
    <div>
      {/* <Year>{year}</Year> */}
      <PeriodInputs year={year} periods={periods} setPeriodInputValue={setPeriodInputValue} />
    </div>
  );
}
